import { NYCBS_OUTCOME_CLASS_OTHERS } from "../../table/utils/getNycbsOutcomeClassBadge";

/** Filter options for the NYCBS External Outcome Class column. */
export const nycbsOutcomeClassFilterOptions = [
  { label: "Drug Not Covered", value: "Drug Not Covered" },
  { label: "Medically Unnecessary", value: "Medically Unnecessary" },
  { label: "Step Therapy Required", value: "Step Therapy Required" },
  { label: NYCBS_OUTCOME_CLASS_OTHERS, value: NYCBS_OUTCOME_CLASS_OTHERS },
];
